export default ({ $integrationsManager }) => {
    const integration = {
        name: 'geolocation',
    }

    if (process.client) {
        integration.plugin = () =>
            import(/* webpackChunkName: "geo-client-plugin" */ './plugin.client')
    } else {
        integration.plugin = () =>
            import(/* webpackChunkName: "geo-server-plugin" */ './plugin.server')
    }

    $integrationsManager.add(integration)
}
